import { Controller, type UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormSection } from '@/shared/ui/components/form';
import { TextInput } from '@/shared/ui/components/form/inputs';
import { PROPERTY_FIELD_LIMITS } from './schema';
import type { PropertyFormValues } from './schema';

interface DocumentationSectionProps {
  form: UseFormReturn<PropertyFormValues>;
}

/**
 * Renders legal documentation fields: registration number (matrícula),
 * registry office (cartório), and inscription number (inscrição imobiliária).
 */
export function DocumentationSection({ form }: DocumentationSectionProps) {
  const { t } = useTranslation('features/properties');
  const errors = form.formState.errors;

  return (
    <FormSection title={t('propertyDrawer.documentation.title')}>
      <Controller
        name="registration_number"
        control={form.control}
        render={({ field }) => (
          <TextInput
            label={t('propertyDrawer.documentation.registrationNumber')}
            value={field.value ?? ''}
            placeholder={t('propertyDrawer.documentation.registrationNumberPlaceholder')}
            maxLength={PROPERTY_FIELD_LIMITS.registrationNumber.maxLength}
            error={errors.registration_number?.message}
            onChange={field.onChange}
          />
        )}
      />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3)' }}>
        <Controller
          name="registry_office"
          control={form.control}
          render={({ field }) => (
            <TextInput
              label={t('propertyDrawer.documentation.registryOffice')}
              value={field.value ?? ''}
              placeholder={t('propertyDrawer.documentation.registryOfficePlaceholder')}
              maxLength={PROPERTY_FIELD_LIMITS.registryOffice.maxLength}
              error={errors.registry_office?.message}
              onChange={field.onChange}
            />
          )}
        />
        <Controller
          name="inscription_number"
          control={form.control}
          render={({ field }) => (
            <TextInput
              label={t('propertyDrawer.documentation.inscriptionNumber')}
              value={field.value ?? ''}
              placeholder={t('propertyDrawer.documentation.inscriptionNumberPlaceholder')}
              maxLength={PROPERTY_FIELD_LIMITS.inscriptionNumber.maxLength}
              error={errors.inscription_number?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>
    </FormSection>
  );
}
